import type { Variant } from "@raumagarn/formatters";
import { clsx } from "@trydig/ui";
import Image from "next/image";
import { stripProductNumber } from "~/lib/centra/utils/stripProductNumber";
import styles from "./yarn-preview-card.module.css";

export const YarnPreviewCard = ({
	yarn,
	selectYarn,
	setPreviewOpen,
	selected,
}: {
	yarn: Variant;
	selectYarn: (yarn: Variant) => void;
	selected: boolean;
	setPreviewOpen?: (open: boolean) => void;
}) => {
	const outOfStock = yarn.items?.every((item) => !item.stock || item.stock === "no");
	const thumb = yarn.media?.[1] || yarn.media?.[0];
	return (
		<button
			onClick={() => {
				selectYarn(yarn);
				setPreviewOpen?.(true);
			}}
			className={clsx(styles.yarn, selected && styles.active, outOfStock && styles.outOfStock)}
		>
			<div className={styles["image-wrapper"]}>
				{(yarn.showAsNew || yarn.newVariantColor) && <p className={styles.tag}>{"Ny"}</p>}
				{thumb && (
					<Image sizes="125px" fill src={thumb.href} alt={yarn.name!} className={styles.image} />
				)}
			</div>
			<span className={styles.yarnSku}>
				<span>{stripProductNumber(yarn.sku!)} </span>
				<span>
					{yarn.variantName?.split("-").at(0)}
					{outOfStock && <span className={clsx(styles.dot, styles.redDot)} />}
					{!outOfStock && yarn.newVariantColor && (
						<span className={clsx(styles.dot, styles.greenDot)} />
					)}
				</span>
			</span>
		</button>
	);
};
